module.exports = __webpack_public_path__ + "img/md-partly-sunny.018889cc.svg";